(function () {
  "use strict";

  function s(value) {
    return value == null ? "" : String(value).trim();
  }

  function arr(value) {
    return Array.isArray(value) ? value : [];
  }

  function esc(value) {
    return s(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function request(url) {
    return fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials:
        new URL(url, location.origin).origin === location.origin
          ? "same-origin"
          : "omit"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP " + response.status);
      }
      return response.json();
    });
  }

  async function withFallback(primary, fallback) {
    try {
      return await request(primary);
    } catch (error) {
      if (!fallback || fallback === primary) throw error;
      return request(fallback);
    }
  }

  function categories(payload) {
    return arr(
      payload &&
        (payload.categories ||
          payload.data ||
          payload.items ||
          payload.results)
    );
  }

  function children(category) {
    return arr(
      category &&
        (category.children ||
          category.Children ||
          category.subCategories ||
          category.SubCategories)
    );
  }

  function cid(category) {
    return s(
      category &&
        (category.id != null
          ? category.id
          : category.ID != null
            ? category.ID
            : category.categoryId != null
              ? category.categoryId
              : category.CategoryId)
    );
  }

  function cname(category) {
    return s(
      category &&
        (category.name ||
          category.Name ||
          category.label ||
          category.CategoryName)
    );
  }

  function flatten(list) {
    var output = [];

    (function walk(nodes) {
      arr(nodes).forEach(function (node) {
        if (!node) return;
        output.push(node);
        walk(children(node));
      });
    })(list);

    return output;
  }

  function products(payload) {
    if (Array.isArray(payload)) return payload;

    return arr(
      payload &&
        (payload.products ||
          payload.items ||
          payload.data ||
          payload.results)
    );
  }

  function pid(product) {
    return s(
      product &&
        (product.id ||
          product.productId ||
          product.ProductId ||
          product.ID)
    );
  }

  function pname(product) {
    return s(
      product &&
        (product.name ||
          product.productName ||
          product.Name ||
          "Sports Apparel")
    );
  }

  function pbrand(product) {
    return s(
      product &&
        (product.brand ||
          product.manufacturer ||
          product.Brand ||
          product.Manufacturer)
    );
  }

  function pcolors(product) {
    return arr(
      product &&
        (product.colors ||
          product.colorways ||
          product.styles)
    );
  }

  function styleId(color) {
    return s(
      color &&
        (color.styleId ||
          color.StyleId ||
          color.id ||
          color.Id)
    );
  }

  function colorName(color) {
    return s(
      color &&
        (color.name ||
          color.colorName ||
          color.label ||
          color.Name)
    );
  }

  function colorImage(color) {
    return s(
      color &&
        (color.imageUrl ||
          color.thumbnailUrl ||
          color.ImageUrl ||
          color.ThumbnailUrl)
    );
  }

  function initialColor(product) {
    var colors = pcolors(product);
    var defaultStyleId = s(
      product &&
        (product.defaultStyleId ||
          product.DefaultStyleId ||
          product.styleId)
    );
    var defaultColor = s(
      product &&
        (product.defaultColor ||
          product.DefaultColor ||
          product.colorName)
    ).toLowerCase();

    var match = null;

    if (defaultStyleId) {
      match = colors.find(function (color) {
        return styleId(color) === defaultStyleId;
      });
    }

    if (!match && defaultColor) {
      match = colors.find(function (color) {
        return colorName(color).toLowerCase() === defaultColor;
      });
    }

    return match || colors[0] || null;
  }

  function productImage(product, color) {
    return (
      colorImage(color) ||
      s(
        product &&
          (product.thumbnailUrl ||
            product.imageUrl ||
            product.primaryImage ||
            product.ImageUrl)
      )
    );
  }

  function isSportsCategoryName(value) {
    var name = s(value)
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!name) return false;

    var patterns = [
      /\bflag\s+football\b/,
      /\bbasketball\b/,
      /\bsoccer\b/,
      /\bvolleyball\b/,
      /\bbaseball\b/,
      /\bsoftball\b/,
      /\bfootball\b/,
      /\blacrosse\b/,
      /\bwrestling\b/,
      /\btennis\b/,
      /\bgolf\b/,
      /\bcheer(?:leading)?\b/,
      /\bhockey\b/,
      /\bswim(?:ming)?\b/,
      /\btrack(?:\s+and\s+field|\s*&\s*field)?\b/,
      /\bcross\s+country\b/,
      /\besports?\b/
    ];

    return patterns.some(function (pattern) {
      return pattern.test(name);
    });
  }

  function uniq(list, keyFn) {
    var seen = new Set();

    return list.filter(function (item) {
      var key = keyFn(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function productUrl(root, product, color) {
    var base =
      root.dataset.productPageBase ||
      "/pages/product-detail-v2?view=unisource-product-detail-v2";

    var url = new URL(base, location.origin);

    url.searchParams.set("productId", pid(product));

    if (color && styleId(color)) {
      url.searchParams.set("styleId", styleId(color));
    }

    if (color && colorName(color)) {
      url.searchParams.set("selectedColor", colorName(color));
    }

    url.searchParams.set(
      "returnUrl",
      location.pathname + location.search + location.hash
    );

    return url.pathname + url.search + url.hash;
  }

  function productCard(root, product) {
    var color = initialColor(product);
    var image = productImage(product, color);
    var url = productUrl(root, product, color);

    return [
      '<article class="ua-pe-card ua-pe-card--product">',
        '<a class="ua-pe-card__image-link" href="' + esc(url) + '">',
          image
            ? '<img src="' + esc(image) + '" alt="' + esc(pname(product)) + '" loading="lazy" decoding="async">'
            : "",
        '</a>',
        '<div class="ua-pe-card__body">',
          '<div class="ua-pe-card__kicker">' + esc(pbrand(product) || "Sports Apparel") + '</div>',
          '<h3 class="ua-pe-card__title">' + esc(pname(product)) + '</h3>',
          '<a class="ua-pe-card__action" href="' + esc(url) + '">View Product</a>',
        '</div>',
      '</article>'
    ].join("");
  }

  async function loadProducts(root) {
    var grid = root.querySelector("[data-sports-products]");
    var status = root.querySelector("[data-sports-products-status]");
    var empty = root.querySelector("[data-sports-products-empty]");

    try {
      var categoryPayload = await withFallback(
        root.dataset.categoriesEndpoint,
        root.dataset.categoriesFallback
      );

      var flat = flatten(categories(categoryPayload));

      var candidateIds = flat
        .filter(function (category) {
          return isSportsCategoryName(cname(category));
        })
        .map(cid)
        .filter(Boolean);

      candidateIds = Array.from(new Set(candidateIds));

      var all = [];

      for (var i = 0; i < candidateIds.length; i += 1) {
        var primary = new URL(
          root.dataset.productsEndpoint,
          location.origin
        );
        primary.searchParams.set("categoryId", candidateIds[i]);
        primary.searchParams.set("page", "1");
        primary.searchParams.set("pageSize", "48");

        var fallback = new URL(
          root.dataset.productsFallback,
          location.origin
        );
        fallback.searchParams.set("categoryId", candidateIds[i]);
        fallback.searchParams.set("page", "1");
        fallback.searchParams.set("pageSize", "48");

        try {
          all = all.concat(
            products(
              await withFallback(
                primary.toString(),
                fallback.toString()
              )
            )
          );
        } catch (_error) {}
      }

      var limit = Math.max(
        1,
        Number(root.dataset.productsLimit || 12)
      );

      all = uniq(all, pid).slice(0, limit);

      grid.innerHTML = all
        .map(function (product) {
          return productCard(root, product);
        })
        .join("");

      grid.setAttribute("aria-busy", "false");

      status.textContent = all.length
        ? all.length +
          (all.length === 1
            ? " sports apparel product shown."
            : " sports apparel products shown.")
        : "No sports apparel products were returned.";

      empty.hidden = !!all.length;
    } catch (error) {
      console.error(
        "[Sports Apparel] product load failed",
        error
      );

      grid.setAttribute("aria-busy", "false");
      status.textContent =
        "Sports apparel is temporarily unavailable.";
      empty.hidden = false;
    }
  }

  function findHeadingByExactText(text) {
    var expected = s(text).toLowerCase();

    return Array.from(
      document.querySelectorAll("h1,h2,h3,h4,h5,h6")
    ).find(function (heading) {
      return s(heading.textContent).toLowerCase() === expected;
    }) || null;
  }

  function closestSharedContentRow(node) {
    if (!node) return null;

    var current = node.parentElement;

    while (
      current &&
      current !== document.body &&
      current !== document.documentElement
    ) {
      /*
       * The SEO landing content/support row contains BOTH:
       * - Sports Apparel for Schools & Teams
       * - Need a specific sport, brand, or garment?
       *
       * Stop at the first ancestor that contains both headings so we
       * remove only that single row, not the FAQ or full landing section.
       */
      var headings = Array.from(
        current.querySelectorAll("h1,h2,h3,h4,h5,h6")
      ).map(function (heading) {
        return s(heading.textContent).toLowerCase();
      });

      if (
        headings.indexOf("sports apparel for schools & teams") !== -1 &&
        headings.indexOf("need a specific sport, brand, or garment?") !== -1
      ) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function lowestCommonAncestor(a, b) {
    if (!a || !b) return null;

    var parents = new Set();
    var node = a;

    while (node) {
      parents.add(node);
      node = node.parentElement;
    }

    node = b;

    while (node) {
      if (parents.has(node)) return node;
      node = node.parentElement;
    }

    return null;
  }

  function widenSportsUpperLanding(rootEl) {
    /*
     * ================================================================
     * SPORTS PAGE WIDTH â€” EXACT PE PAGE METHOD
     * ================================================================
     * Mirrors the working PE page's widenPeUpperLanding() behavior.
     * It tags the shared SEO hero + feature-card wrapper with the SAME
     * .ua-pe-upper-wide class already defined in the PE CSS:
     *
     * width:min(1320px,calc(100vw - 72px))
     * max-width:1320px
     *
     * No shared section code is changed globally.
     * ================================================================
     */
    try {
      var hero = findHeadingByExactText("Custom Sports Apparel");
      var feature = findHeadingByExactText("Team & School Sports");

      if (!hero || !feature) return;

      var common = lowestCommonAncestor(hero, feature);

      if (
        !common ||
        common === document.body ||
        common.contains(rootEl)
      ) {
        return;
      }

      /*
       * This is the same bounded-wrapper climb used by the PE page.
       */
      var candidate = common;
      var node = common;

      while (
        node &&
        node.parentElement &&
        node.parentElement !== document.body
      ) {
        var parent = node.parentElement;

        if (parent.contains(rootEl)) break;
        if (!parent.contains(hero) || !parent.contains(feature)) break;

        var rect = parent.getBoundingClientRect();
        var childRect = node.getBoundingClientRect();

        if (
          rect.width > 0 &&
          rect.width < Math.min(window.innerWidth * 0.94, 1500) &&
          rect.width <= childRect.width + 80
        ) {
          candidate = parent;
          node = parent;
        } else {
          break;
        }
      }

      candidate.classList.add("ua-pe-upper-wide");
      candidate.dataset.sportsUpperWide = "true";
    } catch (error) {
      console.warn(
        "[Sports Apparel] unable to widen upper Sports landing content",
        error
      );
    }
  }

  function applySportsHeroVisual(root) {
    /*
     * ================================================================
     * SPORTS-PAGE-ONLY HERO VISUAL
     * ================================================================
     * The shared SEO landing section owns the live heading/copy/buttons.
     * This function locates only the "Custom Sports Apparel" hero card,
     * then applies the existing Shopify asset unisource-sports-hero-athletes.webp as its hero background.
     *
     * No shared section code is changed globally.
     * ================================================================
     */
    try {
      var imageUrl = s(root && root.dataset.sportsHeroImage);
      if (!imageUrl) return;

      var heroHeading = findHeadingByExactText("Custom Sports Apparel");
      var featureHeading = findHeadingByExactText("Team & School Sports");

      if (!heroHeading) return;

      var shopLink = Array.from(
        document.querySelectorAll('a[href="#shop-sports-apparel"]')
      )[0] || null;

      var candidate = heroHeading.parentElement;
      var node = candidate;

      while (
        node &&
        node.parentElement &&
        node.parentElement !== document.body
      ) {
        var parent = node.parentElement;

        if (!parent.contains(heroHeading)) break;

        /*
         * Keep climbing while we are still inside the hero.
         * Stop before the wrapper that also contains the feature cards.
         */
        if (
          featureHeading &&
          parent.contains(featureHeading)
        ) {
          break;
        }

        if (
          shopLink &&
          !parent.contains(shopLink)
        ) {
          node = parent;
          continue;
        }

        candidate = parent;
        node = parent;
      }

      if (!candidate) return;

      candidate.classList.add("ua-sports-hero--with-athletes");
      candidate.style.setProperty(
        "--ua-sports-hero-image",
        'url("' + imageUrl.replace(/"/g, "%22") + '")'
      );
      candidate.dataset.sportsHeroVisual = "athlete-lineup-v1";
    } catch (error) {
      console.warn(
        "[Sports Apparel] unable to apply athlete hero visual",
        error
      );
    }
  }

  function placeSportsGridInMainFlow(root) {
    /*
     * ================================================================
     * SPORTS PAGE CONTENT ORDER
     * ================================================================
     * Replace the generic long-form SEO content/support row with the
     * real Sports Apparel product showcase.
     *
     * Final order:
     *   Hero
     *   Four feature cards
     *   Sports Apparel product grid
     *   Custom quote block
     *   Sports Apparel Questions
     *
     * This is Sports-page-only DOM movement. The shared
     * unisource-seo-category-landing section is not modified globally.
     * ================================================================
     */
    try {
      var contentHeading = findHeadingByExactText(
        "Sports Apparel for Schools & Teams"
      );

      if (!contentHeading) return;

      var contentRow = closestSharedContentRow(contentHeading);
      if (!contentRow || !contentRow.parentElement) return;

      var parent = contentRow.parentElement;

      /*
       * Move the dedicated Sports showcase into the exact position
       * previously occupied by the content/support row.
       */
      parent.insertBefore(root, contentRow);

      /*
       * Remove only the obsolete two-column row.
       */
      contentRow.remove();

      root.dataset.sportsPromotedCoreContent = "true";
    } catch (error) {
      console.warn(
        "[Sports Apparel] unable to promote product grid",
        error
      );
    }
  }

  function init(root) {
    if (!root || root.dataset.uaSportsReady === "true") return;

    root.dataset.uaSportsReady = "true";

    /*
     * Match the exact upper-page width behavior used by PE Uniforms.
     */
    widenSportsUpperLanding(root);

    /*
     * Apply the Sports-specific athlete hero without touching the
     * shared SEO landing section globally.
     */
    applySportsHeroVisual(root);

    /*
     * Position the product grid before loading so customers do not see
     * the old content row flash above it.
     */
    placeSportsGridInMainFlow(root);
    loadProducts(root);
  }

  function start() {
    document
      .querySelectorAll("[data-ua-sports-apparel]")
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }
})();